import cogoToast from "cogo-toast-react-17-fix";
import { useEffect, useState } from "react";
import { BASE_URL, GET_ISSUER, GET_VERIFIER } from "../../Utils/constant";
import API from "../../ApiConfig";
import { useSelector } from "react-redux";
import { Delay } from "../../Utils/helper";
const useRazorpayPayment = (verifierId, setLoading) => {

  const UserDetails=useSelector(state => state.cart.user)
  const cost=useSelector(state=>state.cart.cost)  
  useEffect(() => {
    if (!document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]')) {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const initiatePayment = () => {
    if(cost.total_amount_payable>=1){
    setLoading(true)
    return new Promise((resolve, reject) => {
      fetch(`${BASE_URL}api/v1/payment/initiate-payment`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          verifier_id: verifierId,
          amount: 1,
          description: "Testing",
          currency: "INR"
        })
      })
        .then(response => response.json())
        .then(order => {
          setLoading(false)
          if (!order.data) {
            throw new Error("Failed to initiate payment");
          }

          const options = {
            key: order.data.key_id,
            amount: order.data.amount,
            currency: "INR",
            name: "AuthNumber",
            description: order.data.description,
            order_id: order.data.razorpay_order_id,
            handler: response => {
              setLoading(true)
              fetch(`${BASE_URL}api/v1/payment/verify-payment`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  verifier_id: verifierId,
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_signature: response.razorpay_signature
                })
              })
                .then(verifyResponse => verifyResponse.json())
                .then(result => {
                  if (result.success) {
                    setLoading(false)
                    resolve(result); // Return the verification response
                  } else {
                    setLoading(false)
                    resolve(null);
                  }
                })
                .catch(error => {
                  setLoading(false)
                  resolve(null);
                });
            },
            modal: {
              ondismiss: function () {
                setLoading(false);
                // Cancel the transaction when payment dialog is closed
                fetch(`${BASE_URL}api/v1/payment/cancel-transaction`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    razorpay_order_id: order.data.razorpay_order_id
                  })
                })
                .then(response => response.json())
                .then(result => {
                  console.log("Transaction cancelled:", result);
                })
                .catch(error => {
                  console.error("Error cancelling transaction:", error);
                });
                resolve(null);
              }
            },
            prefill: {
              name: UserDetails?.name,
              email: UserDetails?.email,
              contact: UserDetails?.phone_number
            },
            theme: { color: "#3399cc" }
          };

          const rzp1 = new window.Razorpay(options);
          rzp1.open();
        })
        .catch(error => {
          console.error("Payment initiation error:", error);
          // alert(error.message || "Failed to initiate payment.");
          reject(error);
        });
    });
  }
  else{
    cogoToast.error("Final amount is less than 1 rupess please add more amount in your wallet!!")
  }
  };

  return initiatePayment;
};

export default useRazorpayPayment;
